import React, { Component } from 'react'
import { PieChart } from 'react-minimal-pie-chart';

export class MyChart extends Component {
    render() {
        return (
            <div>
                <PieChart
                    data={[
                        { title: 'One', value: 30, color: 'rgba(45,219,244,1)', background: 'blue', title: '30%' },
                        { title: 'Two', value: 40, color: 'rgba(137,84,244,1)', background: 'blue',  title: '40%' },
                        { title: 'Three', value: 30, color: 'rgba(36,255,218,1)', background: 'red', title: '30%' },
                    ]}
                />
            </div>
        )
    }
}








export class StatChart extends Component {
    render() {
        return (
            <div>

                <PieChart
                    data={[
                        { title: 'One', value: 30, color: 'rgba(45,219,244,1)', background: 'blue', title: '30%' },
                        { title: 'Two', value: 40, color: 'rgba(137,84,244,1)', background: 'blue',  title: '40%' }
                    ]}
                />
            </div>
        )
    }
}

export default MyChart;